<template>
  <div>
    <div class="bg-white mt-20 mb-5">
      <Banner />
      <EventsCorner />
      <WeOffer />
      <Highlights />
      <!-- <CampaignForm /> -->
      <ProfessionalsForm />
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import Highlights from "./components/Highlights.vue";
import WeOffer from "./components/WeOffer.vue";
import EventsCorner from "./components/EventsCorner.vue";
import CampaignForm from "./components/CampaignForm.vue";
import ProfessionalsForm from "../request-form/components/ProfessionalsForm.vue";
import Footer from "../Footer.vue";
import DownloadApp from "../corporate-events/components/DownloadApp.vue";

export default {
  components: {
    Banner,
    Highlights,
    WeOffer,
    EventsCorner,
    CampaignForm,
    ProfessionalsForm,
    Footer,
    DownloadApp,
  },
};
</script>
